<sura-admin [linkActive] = "linkActive"></sura-admin>
<div class="container  pl-0 pr-0" id="form-resultado">
    <div style="padding: 10px 0px"></div>
    <div class="card shadow mb-5 bg-white rounded " style="margin: auto;">
        <div class="card-header">
           Resultados
        </div>
        <div class="text-right">
            <button class="btn btn-default" (click)="openFull()" *ngIf="isFullScreen">
                <mat-icon aria-label="fullscreen">fullscreen</mat-icon>
            </button>
            <button class="btn btn-default" (click)="closeFull()" *ngIf="!isFullScreen">
                <mat-icon aria-label="fullscreen_exit">fullscreen_exit</mat-icon>
            </button>
        </div>
        <form action="" class="card-body pr-0 pl-0">
           <div class="row justify-content-center">
                <div class="col-6">
	                <label class="col-md-3 col-12 col-form-label">Nro. Asamblea:</label>
	                <mat-form-field class="col-md-9 col-12" appearance="outline">
	                    <input matInput placeholder="" name="asamblea"
	                    [formControl]="nroAsambleaValidacion" [(ngModel)]="newEstadistica.idAsamblea" required maxlength="6" (keypress) = "fnKeyDownNumeric($event)" (keyup) = "fnNumericMobile($event)"  (input)="fnInputMaxLength($event);">
	                    <mat-error *ngIf="nroAsambleaValidacion.invalid">{{getErrorMessageNroAsamblea()}}</mat-error>
	                </mat-form-field>
				</div>
				<div class="col-6 text-left pl-0 pt-4 pt-md-0 content-btn padding-top-butons-sura">
            		 <button mat-mini-fab color="primary" matTooltip="Buscar Asamblea" [disabled]="nroAsambleaValidacion.invalid" matSuffix   aria-label="Clear"
	                        (click)="buscarPregunta()">
	                            <mat-icon>search</mat-icon>
	                    </button>
            	</div>
            </div>
            <div class="row justify-content-start">
	            <div class="col-6">
	                <label class="col-md-3 col-12 col-form-label">Votaci&oacute;n:</label>
	                <mat-form-field class="col-md-9 col-12" appearance="outline">
	                    <mat-select placeholder="Seleccione" [(ngModel)]="newEstadistica.idPregunta" name="pregunta" (ngModelChange)="buscarEstadistica()">
	                        <mat-option *ngFor="let pregunta of listPreguntas" [value]="pregunta.id">
	                                {{pregunta.orden}}.- {{pregunta.descripcion}}
	                        </mat-option>
	                    </mat-select>
	                </mat-form-field>
                </div>

                <div class="padding-top-butons-sura">

                    <button *ngIf="(newEstadistica.estado == 'P')" mat-raised-button type="button" color="primary" (click)="iniciarVotacion()" [disabled]="newEstadistica.idPregunta == null">
                        <mat-icon aria-label="icon-button with a heart icon">slow_motion_video</mat-icon>
                        &nbsp;&nbsp;Iniciar votaci&oacute;n
                    </button>

                    <button *ngIf="(newEstadistica.estado == 'I')" mat-raised-button type="button"  color="primary" (click)="finalizarVotacion()">
                        <mat-icon aria-label="icon-button with a heart icon">slow_motion_video</mat-icon>
                        &nbsp;&nbsp;Finalizar votaci&oacute;n
                    </button>


                    <button *ngIf="(newEstadistica.estado == 'F')" mat-raised-button type="button"  color="primary"  [disabled]="newEstadistica.idPregunta == null " (click)="openDialogEnviarResultado()">
                        <mat-icon aria-label="icon-button with a heart icon">contact_mail</mat-icon>
                        &nbsp;&nbsp; Enviar resultado
                    </button>


                </div>

            </div>
        </form>
        <div class="row margin-bottom-55">
            <div class="col-sm-12 col-md-8">
                <div id="canvas-holder" style="width:100%;margin-bottom: 10px">
                    <canvas id="chart-area" ></canvas>
                </div>

            </div>
            <div class="col-sm-12 col-md-4">

              <div class="row">
            		<div class="col-6"># qu&oacute;um</div>
            		<div class="col-1">:</div>
            		<div class="col-4 text-right">{{newEstadistica.totalQuorum}}</div>
            		<div class="col-1"></div>
            	</div>

                <div class="row">
            		<div class="col-6"># Total de cuotas</div>
            		<div class="col-1">:</div>
            		<div class="col-4 text-right">{{newEstadistica.totalCuotasAsamblea}}</div>
            		<div class="col-1"></div>
            	</div>
                <div class="row">
            		<div class="col-6"># Cuotas que han votado</div>
            		<div class="col-1">:</div>
            		<div class="col-4 text-right">{{newEstadistica.totalCuotas}}</div>
            		<div class="col-1"></div>
            	</div>

            	<div class="row">
            		<div class="col-6"># Total Miembros</div>
            		<div class="col-1">:</div>
            		<div class="col-4 text-right">{{newEstadistica.totalMiembros}}</div>
            		<div class="col-1"></div>
            	</div>
            	<div class="row">
            		<div class="col-6"># Total Asistentes</div>
            		<div class="col-1">:</div>
            		<div class="col-4 text-right">{{newEstadistica.totalAsistentes}}</div>
            		<div class="col-1"></div>
            	</div>
            	<div class="row">
            		<div class="col-6"># Total Votos</div>
            		<div class="col-1">:</div>
            		<div class="col-4 text-right">{{newEstadistica.totalVotos}}</div>
            		<div class="col-1"></div>
            	</div>

                <br>
                <div class=" justify-content-sm-center text-center">
                    <p class="mb-3"><strong>Tiempo Restante:</strong></p>
                    <div class="d-flex justify-content-center" >
                            <div class="input-group mb-3" style="width: auto;">
                                    <div class="input-group-prepend">
                                      <span class="input-group-text">
                                            <mat-icon matSuffix>timer</mat-icon>
                                      </span>
                                      <span class="input-group-text" id="intervalTiempoRestante">00 : 00</span>
                                    </div>
                                    <div class="input-group-append" *ngIf="newEstadistica.estado == 'I'">
                                            <button matTooltip="Editar tiempo" mat-flat-button color="primary" class="btn btn-light " (click)="openDialogAumentarTiempo()" style="    border: 1px solid #ced4da;">
                                                    <mat-icon aria-label="icon-button with a heart icon">edit</mat-icon></button>
                                    </div>
                            </div>
                    </div>
                </div>
                <div class="row justify-content-sm-center text-center">
                        <img class="img-fluid border-0" style="-webkit-user-select: none; margin: auto;"
                        src="https://quickchart.io/qr?text=http%3A%2F%2Fasamblea.sura.net.pe%2Fvoto&size=200" alt="http://asamblea.sura.net.pe/voto">
                </div>
            </div>
        </div>
    </div>
</div>
